import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import axios from 'axios';

import { paymentMethodModelGet, } from '../../models/paymentMethods/paymentMethod';
import { responseGet, globalSettings, styles, buttonProcessGet, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay, } from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'PaymentMethodsAddEdit';

const { app, collections: dbColle, icons, images, labels, messages, react } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;
const { properties: dbProps, } = dbColle;

export default function PaymentMethodsAddEdit({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    paymentMethod = paymentMethodModelGet({}),
    setPaymentMethod = () => { },
    dtId = '',
    dtObj = {},
    dtRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region initialize
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    //#endregion initialize

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnPaymentMethodModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnPaymentMethodModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnPaymentMethodModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            isCash: {
                id: 'chkPaymentMethodModalIsCash',
                className: 'icheck-primary d-inline',
            },
            showBanks: {
                id: 'chkPaymentMethodModalShowBanks',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoPaymentMethodModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoPaymentMethodModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoPaymentMethodModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputPaymentMethodModalDescription',
                className: 'form-control',
            },
            // code: {
            //     id: 'inputPaymentMethodModalCode',
            //     className: 'form-control',
            // },
            // rif: {
            //     id: 'inputPaymentMethodModalRif',
            //     className: 'form-control',
            // },
        },
        selects: {
            countries: {
                id: 'selPaymentMethodModalCountries',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spPaymentMethodModalSave',
                className: '',
            },
            back: {
                id: 'spPaymentMethodModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (paymentMethods)
    const paymentMethodAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentMethodAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                paymentMethod: paymentMethod,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPaymentMethods}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            paymentMethod = response?.result || {};
            $(`#${dtId}`)?.DataTable()?.row?.add([
                paymentMethod?.description,
                buttonProcessGet({
                    id: paymentMethod?.id,
                    description: paymentMethod?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const paymentMethodEditGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentMethodEditGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                paymentMethod: paymentMethod,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPaymentMethods}/${paymentMethod?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            paymentMethod = response.result || {};

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex)?.data?.([
                paymentMethod?.description,
                buttonProcessGet({
                    id: paymentMethod?.id,
                    description: paymentMethod?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (paymentMethods)

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const validateFormData = ({
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: paymentMethod?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.checkBox?.isCash?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.checkBox?.showBanks?.id}`)?.attr({ disabled: processType !== 0, });
            //$(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, [showModal]);
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync(true)}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='banks'
                        src={images?.paymentMethodsLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.paymentMethod?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                paymentMethodAddPostAsync({ e: e, subMethod: 'btn - paymentMethodAdd', }) :
                paymentMethodEditGetAsync({ e: e, subMethod: 'btn - paymentMethodUpdate', })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? paymentMethodAddPostAsync(e) : paymentMethodEditGetAsync(e)}> */}

                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt={labels?.paymentMethod?.[languageObj?.id]} src={images?.paymentMethodsLogo} style={styles?.cardHeaderLogo}>
                            </img> - {labels?.paymentMethod?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.description?.id}
                                        className={controls?.inputs?.description?.className}
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        onChange={(e) => setPaymentMethod({
                                            ...paymentMethod,
                                            [dbProps?.description]: e?.target?.value,
                                        })}
                                        onFocus={() => setDescriptionError('')}
                                        value={paymentMethod?.description || ''}
                                        tooltip='tooltip' title={labels?.name?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group'>
                                    <div className={controls?.checkBox?.isCash?.className}>
                                        <input id={controls?.checkBox?.isCash?.id}
                                            checked={paymentMethod?.isCash || false}
                                            onChange={(e) => setPaymentMethod({
                                                ...paymentMethod,
                                                [dbProps?.isCash]: e?.target?.checked,
                                            })}
                                            tooltip='tooltip'
                                            title={`${labels?.isCash?.[languageObj?.id]}?`}
                                            type='checkbox' />
                                        <label className='text-muted'
                                            htmlFor={controls?.checkBox?.isCash?.id}
                                            tooltip='tooltip'
                                            title={`${labels?.isCash?.[languageObj?.id]}?`}> {labels?.isCash?.[languageObj?.id]}?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <div className='input-group'>
                                    <div className={controls?.checkBox?.showBanks?.className}>
                                        <input id={controls?.checkBox?.showBanks?.id}
                                            checked={paymentMethod?.showBanks || false}
                                            onChange={(e) => setPaymentMethod({
                                                ...paymentMethod,
                                                [dbProps?.showBanks]: e?.target?.checked,
                                            })}
                                            tooltip='tooltip'
                                            title={`${labels?.showBanks?.[languageObj?.id]}?`}
                                            type='checkbox' />
                                        <label className='text-muted'
                                            htmlFor={controls?.checkBox?.showBanks?.id}
                                            tooltip='tooltip'
                                            title={`${labels?.showBanks?.[languageObj?.id]}?`}> {labels?.showBanks?.[languageObj?.id]}?</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <select defaultValue={paymentMethod.countryId} className='form-select' onChange={(e) => localFormDataSet('countryId', e?.target?.value)} onFocus={() => setCountryIdError('')}>
                                            <option key='nothing' value=''>{labels?.selectCountry}</option>
                                            {countries.map((country) => <option key={country.id} value={country.id}>{country.description}</option>)};
                                        </select>
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className='fas fa-globe-americas' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(countryIdError)}</div>
                                </div> */}

                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip' title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}